import React from "react"
import { ActiveSubstitutionBanner } from "~Features/settings/absenceManagement/ActiveSubstitutionBanner"
import { BillingPaymentSignUpBanner } from "~Features/settings/billing/billingPaymentSignUp.banner"
import BeneficiaryStatus from "./beneficiaryStatus.banner"
import DatevOnlineErrorBanner from "./datevOnlineError.banner"
import SpreadsheetImportInProgressBanner from "./spreadsheetImportInProgress.banner"
import WeavrOnBoardingBanner from "./weavrOnBoarding.banner"

export const BannerContainer = () => (
    <div className="finway-global-banner mx-10 md:mx-0">
        <ActiveSubstitutionBanner />
        <BillingPaymentSignUpBanner />
        <WeavrOnBoardingBanner />
        <SpreadsheetImportInProgressBanner />
        <DatevOnlineErrorBanner />
        <BeneficiaryStatus />
    </div>
)
